let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4aw15")).then(() => parcelRequire('1R8sa'));